import { render, staticRenderFns } from "./index.vue?vue&type=template&id=415c491e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c491e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('415c491e')) {
      api.createRecord('415c491e', component.options)
    } else {
      api.reload('415c491e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=415c491e&scoped=true&", function () {
      api.rerender('415c491e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wxfansmsg/index.vue"
export default component.exports